const domains = {
	"prod.fe.cam-loy-wilkinson-intuition-hawaiian-2026-frontend.campaign-loyalty.com": {
		apibase: "/",
		recaptchakey: "6Lcwxx8qAAAAAMk6Zz9QTup3mT8AEHCVdx0e152C",
	},
}
export const getEnvConfig = () => {
	return (
		domains[window.location.host] || { apibase: "/inte/", recaptchakey: "6Lcwxx8qAAAAAMk6Zz9QTup3mT8AEHCVdx0e152C" }
	)
}
